<template>
<div class="card-item"
  :id="item.itemId">
  <div class="card-item-heading">{{ item.heading }}</div>
  <div class="card-item-content">
    <my-date v-bind:date="item.data.date">
    </my-date>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {}
  },
  props: ['item'],
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>
